export const GROUPS = [
  {
    slug: "hen-stag",
    tag: "Hen & Stag",
    title: "Hen & Stag Parties",
    short:
      "The ideal destination for your next hen or stag party \u2014 adventure by day, your own private bar by night.",
    heroImage: "/images/hen-party-paddles.webp",
    bodyImage: "/images/sumo-hen.webp",
    price: "From \u20AC50pp",
    capacity: "20\u2013100 guests",
    paragraphs: [
      "Collanmore Island Lodge offers the ideal destination for your next hen or stag party, team building activity, product launch and more.",
      "Sea kayaking: explore the pristine waters of Clew Bay as you glide through its tranquil waves on our sea kayaks. Discover hidden coves, secluded beaches and marvel at the rich marine life that calls these waters home.",
      "Stand-up paddleboarding: experience the thrill of SUP against the backdrop of stunning coastal vistas. Whether you're a seasoned pro or a first-time paddler, our instructors will guide you through the basics and ensure an unforgettable adventure.",
      "Sea Safari: embark on an exhilarating sea safari around Clew Bay and encounter fascinating wildlife, including seals, dolphins and seabirds, with expert guides leading an immersive journey through these pristine waters.",
    ],
    highlights: [
      "We personalise all our experiences",
      "We will create a magical all-inclusive package for your event",
      "We are just 2 minutes from the mainland, on a private island",
      "Looking for something unique and special? Just get in touch",
    ],
  },
  {
    slug: "corporate",
    tag: "Corporate",
    title: "Corporate & Team Building",
    short:
      "A private island venue for your exclusive use \u2014 strategy development, team building and private engagement with staff and clients.",
    heroImage: "/images/corporate.jpg",
    bodyImage: "/images/kayak-group.jpg",
    price: "From \u20AC50pp",
    capacity: "20\u2013100 guests \u00B7 lodge sleeps 22",
    paragraphs: [
      "Collanmore Island Lodge offers a private venue for your exclusive use for the duration of your stay. With ample space and amenities for up to 22 people, it provides the ideal environment for strategy development and private engagement with staff and clients.",
      "Create your own bespoke activity and entertainment package to suit the requirements of your stay. Our range of adventure activities includes bushcraft and raft building, which are ideal for team development \u2014 even a two-man band will come and play for you in your own private bar.",
      "New beach sauna, new seaweed bath, new pontoon, new high-speed RIB. Our experienced team will fully coordinate your activity and entertainment package to ensure you enjoy a hassle-free, memorable experience that adds value to your stay.",
    ],
    highlights: [
      "Private island venue for your exclusive use",
      "Bespoke activity & entertainment packages",
      "Bushcraft & raft building for team development",
      "Beach sauna, seaweed bath, pontoon & high-speed RIB",
      "Fantastic entertainment for your entire group",
    ],
  },
  {
    slug: "schools-youth",
    tag: "Schools & Youth",
    title: "School & Youth Groups",
    short:
      "A perfect blend of adventure, learning and exploration in the stunning setting of Clew Bay.",
    heroImage: "/images/school-tour.jpg",
    bodyImage: "/images/kayaking-group.jpg",
    price: "From \u20AC35pp",
    capacity: "20\u2013100 students",
    paragraphs: [
      "Looking for an exciting and educational experience for your students? Our school tours offer a perfect blend of adventure, learning and exploration in the stunning setting of Clew Bay.",
      "Let your students explore the crystal-clear waters of Clew Bay on our sit-on-top kayaks, with experienced instructors guiding them through the basics of paddling and safety \u2014 a fun and rewarding experience for all skill levels.",
      "Hold on tight on an exhilarating ride aboard our high-speed RIBs, zip across the bay and explore hidden coves and landmarks \u2014 then immerse your students in the natural beauty of Clew Bay with guided island walks and a leisurely picnic amidst stunning landscapes.",
      "Learn about the rich biodiversity of Clew Bay and its importance as a marine habitat, discover the significance of preserving our natural environment, and develop teamwork, communication and leadership skills through interactive activities and challenges.",
    ],
    highlights: [
      "Sit-on-top kayaking with safety-first instructors",
      "Stand-up paddleboarding",
      "High-speed RIB rides",
      "Guided island walks & picnics",
      "Biodiversity & conservation learning",
      "Teamwork and leadership development",
    ],
  },
  {
    slug: "families",
    tag: "Families",
    title: "Family Adventures",
    short:
      "Birthday parties, reunions, anniversaries \u2014 or just a day of island fun with the people you love.",
    heroImage: "/images/grp-families-hero.jpg",
    bodyImage: "/images/birthday-party.webp",
    price: "From \u20AC45pp",
    capacity: "4\u201330 guests",
    paragraphs: [
      "Collanmore Island Lodge offers the ideal destination for your next family occasion. Family parties are all about creating lasting memories with loved ones.",
      "Choose from a variety of themes \u2014 from birthday parties and reunions to anniversaries and special occasions. Include games, music, decorations and delicious food to make the celebration memorable.",
      "Family parties are about joy, connection and celebration. Book your tickets and create magical moments with your loved ones.",
    ],
    highlights: [
      "Private island all to yourself",
      "Lots of water activities to do",
      "Private pontoon and beach",
      "Hot tubs and saunas",
    ],
  },
];
